module.exports = __webpack_public_path__ + "img/gregorya.1ea1d00a.jpg";